import {
  CUSTOM_ELEMENTS_SCHEMA,
  LOCALE_ID,
  NgModule,
  isDevMode,
} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { OverlayModule } from '@angular/cdk/overlay';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module';
import {
  NgbDateParserFormatter,
  NgbDatepickerI18n,
  NgbModule,
} from '@ng-bootstrap/ng-bootstrap';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { StoreModule } from '@ngrx/store';
import { MaterialModuleModule } from './materialModule/material-module/material-module.module';
import { CommonModule, registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import { NgxSliderModule } from 'ngx-slider-v2';
import { HttpClientModule } from '@angular/common/http';
import { InterceptorModule } from './shared/guard/interceptor/interceptor.module';
import { ExtratoComponent } from './components/extrato/extrato/extrato.component';
import { TransferenciaComponent } from './components/transferencia/transferencia/transferencia/transferencia.component';
import { SaqueCopiaColaComponent } from './components/transferencia/saque-copia-cola/saque-copia-cola/saque-copia-cola.component';
import { TransferBalanceComponent } from './components/transfer-balance/transfer-balance.component';
import { CryptomoedaComponent } from './components/cryptomoeda/cryptomoeda.component';
import { TableTransactionsDirective } from './components/table-transactions/table-transactions.directive';
import { NgbDatePTParserFormatter } from './utils/ngbdateparse.formatter';
import { CustomDatepickerI18n, I18n } from './utils/custom.datepicker';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import {
  NgxMaskDirective,
  NgxMaskPipe,
  provideEnvironmentNgxMask,
} from 'ngx-mask';
import {
  provideEnvironmentNgxCurrency,
  NgxCurrencyInputMode,
  NgxCurrencyDirective,
} from 'ngx-currency';
import { ServiceWorkerModule } from '@angular/service-worker';
import { DepositComponent } from './components/deposit/deposit/deposit/deposit.component';
import { DepositPixComponent } from './components/deposit/depositPix/depositPix/depositPix.component';
import { ViewAccountComponent } from './components/account/view-account/view-account.component';
import { WalletComponent } from './components/wallet/wallet.component';
import { AccountComponent } from './components/account/account/account.component';
import { WebhookComponent } from './components/webhook/webhook.component';
import { FormComponent } from './components/prospect/form/form.component';
import { ApproveComponent } from './components/withdraw/approve/approve.component';
import { ApproveadminComponent } from './components/withdraw/approveadmin/approveadmin.component';
import { ConponentsModule } from './components/components.module';

registerLocaleData(localePt);

@NgModule({
  declarations: [
    AppComponent,
    ExtratoComponent,
    TransferenciaComponent,
    SaqueCopiaColaComponent,
    TransferBalanceComponent,
    CryptomoedaComponent,
    TableTransactionsDirective,
    DepositComponent,
    DepositPixComponent,
    ViewAccountComponent,
    WalletComponent,
    AccountComponent,
    WebhookComponent,
    FormComponent,
    ApproveComponent,
    ApproveadminComponent,
  ],
  imports: [
    CommonModule,
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    NgbModule,
    BrowserAnimationsModule,
    OverlayModule,
    ToastrModule.forRoot({}),
    StoreModule.forRoot({}),
    MaterialModuleModule,
    NgxSliderModule,
    HttpClientModule,
    InterceptorModule,
    FormsModule,
    NgSelectModule,
    NgxMaskDirective,
    NgxMaskPipe,
    ReactiveFormsModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode(),
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000',
    }),
    NgxCurrencyDirective,
    ConponentsModule,
  ],
  providers: [
    [I18n, { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n }],
    [{ provide: NgbDateParserFormatter, useClass: NgbDatePTParserFormatter }],
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    provideEnvironmentNgxMask(),
    provideEnvironmentNgxCurrency({
      align: 'left',
      allowNegative: false,
      allowZero: true,
      decimal: ',',
      precision: 2,
      prefix: 'R$ ',
      suffix: '',
      thousands: '.',
      nullable: true,
      min: null,
      max: null,
      inputMode: NgxCurrencyInputMode.Financial,
    }),
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor() {}
}
